import { PlanMode } from 'mbs-ui-shared@models/PlanTypes.enum';
import { BaseForStepsHelper, WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { RestoreStepsDataFromPlanHelper } from 'wizards/helpers/restore-steps-data-from-plan-helper/restore-steps-data-from-plan-helper';
import { StepsDataFromPlanHelper } from 'wizards/helpers/steps-data-from-plan-helper/steps-data-from-plan-helper';
import { SupportMethodsForStepsFromPlan } from 'wizards/helpers/support-methods-for-steps-from-plan';
import { RestoreFileFormModel } from 'wizards/models/restoreFile/restore-file-form-model';

export class RestoreFileModelForStepHelpers extends BaseForStepsHelper {
  public static RestoreFileModel: RestoreFileFormModel;

  public static RestoreFileModelFromPlan(plan, settings: WizardHelpersSettings = this.DefaultSettings): RestoreFileFormModel {
    this.RestoreFileModel = new RestoreFileFormModel(settings.isNBF, settings.isUnix);
    const newPlan = (plan && plan.plan) || (plan && plan.Plan);
    if (newPlan) {
      this.setThisValues(plan, settings);
      this.setStorageType(settings.mode, newPlan.HybridID, newPlan.ConnectionID);
      this.updatePlanNameStep(newPlan, settings.compName);
      this.updateWhereBackupStep(newPlan);

      const { backupPlanName, restorePoint } = this.getBackupNameAndPoint(newPlan);

      this.RestoreFileModel.computerToRestoreStep.computerName = newPlan.RestoreSourcePrefix || '';
      this.RestoreFileModel.backupToRestoreStep = RestoreStepsDataFromPlanHelper.updateBackupToRestore(
        newPlan,
        this.planType,
        backupPlanName,
        settings.isUnix
      );
      this.RestoreFileModel.restorePointStep = RestoreStepsDataFromPlanHelper.updateRestorePoint(
        newPlan,
        true,
        restorePoint,
        settings.timeZoneOffset,
        settings.isUnix
      );
      this.RestoreFileModel.restoreSourceStep = RestoreStepsDataFromPlanHelper.updateRestoreSource(newPlan, this.isUnix, settings.compName);
      this.RestoreFileModel.destinationStep = RestoreStepsDataFromPlanHelper.updateDestinationStep(
        newPlan,
        true,
        [],
        this.isUnix,
        this.isNBF
      );
      this.RestoreFileModel.encryptionOptionsStep = RestoreStepsDataFromPlanHelper.updateEncryptionOptionsStep(
        newPlan,
        settings.mode === PlanMode.create,
        this.isNBF
      );
      this.RestoreFileModel.scheduleStep = StepsDataFromPlanHelper.updateSchedule(
        newPlan,
        plan.OverdueAfterSuccess,
        this.isCreate,
        this.isUnix,
        true
      );
      this.RestoreFileModel.prePostActionsStep = StepsDataFromPlanHelper.updatePrePostActions(newPlan, true);
      this.RestoreFileModel.notificationStep = StepsDataFromPlanHelper.updateNotification(newPlan.Notification);
    }
    return this.RestoreFileModel;
  }

  public static updatePlanNameStep(newPlan, compName: string): void {
    const name = newPlan.Name || SupportMethodsForStepsFromPlan.generatePlanName(compName, this.planType, this.timeZoneOffset);
    this.RestoreFileModel.planNameStep = RestoreStepsDataFromPlanHelper.updatePlanNameStep(name, newPlan.DeletePlan);
  }
  public static updateWhereBackupStep(newPlan): void {
    this.RestoreFileModel.whereBackupStep = StepsDataFromPlanHelper.updateWhereBackup(
      newPlan.IsHybridBackup,
      newPlan.HybridID,
      newPlan.ConnectionID
    );
    this.RestoreFileModel.Storages = this.storages;
  }
}
